export const shouldPromptCreatePassword = ({ isInitialized, user } = {}) => {
  if (!isInitialized || !user) return false;

  return user.has_usable_password === false;
};

export default function useShouldPromptCreatePassword({ isInitialized, user } = {}) {
  return shouldPromptCreatePassword({ isInitialized, user });
}
